__turbopack_context__.v({
  "autoSlide": "ArticleMediaCarousel-module-scss-module__DrAIDW__autoSlide",
  "carousel": "ArticleMediaCarousel-module-scss-module__DrAIDW__carousel",
  "clickable": "ArticleMediaCarousel-module-scss-module__DrAIDW__clickable",
  "lightboxBackdrop": "ArticleMediaCarousel-module-scss-module__DrAIDW__lightboxBackdrop",
  "lightboxBody": "ArticleMediaCarousel-module-scss-module__DrAIDW__lightboxBody",
  "lightboxClose": "ArticleMediaCarousel-module-scss-module__DrAIDW__lightboxClose",
  "lightboxInner": "ArticleMediaCarousel-module-scss-module__DrAIDW__lightboxInner",
  "lightboxSwiper": "ArticleMediaCarousel-module-scss-module__DrAIDW__lightboxSwiper",
  "mediaWrapper": "ArticleMediaCarousel-module-scss-module__DrAIDW__mediaWrapper",
  "playerFrame": "ArticleMediaCarousel-module-scss-module__DrAIDW__playerFrame",
  "playerInner": "ArticleMediaCarousel-module-scss-module__DrAIDW__playerInner",
  "playerOuter": "ArticleMediaCarousel-module-scss-module__DrAIDW__playerOuter",
  "slideBox": "ArticleMediaCarousel-module-scss-module__DrAIDW__slideBox",
});
